import { createReducer, createActions } from 'reduxsauce'
import Immutable, { type ImmutableObject } from 'seamless-immutable'

import type {
  GetNotificationPreferencesSuccessPayload,
  NotificationsState,
} from 'APP/Store/Notifications/types'

const actionDefs = {
  getNotificationPreferences: [],
  updateNotificationPreference: ['data'],
  getNotificationPreferencesSuccess: ['data'],
  getNotificationPreferencesFailure: ['error'],
  triggerNotificationPermissionModal: [],
} as const satisfies Record<string, string[]>

type TActions = typeof actionDefs
type TPayloads = {
  getNotificationPreferencesSuccess: GetNotificationPreferencesSuccessPayload
}

const { Types, Creators } = createActions<TPayloads, TActions>(actionDefs)

export const NotificationTypes = Types
export default Creators

type ImmutableNotificationsState = ImmutableObject<NotificationsState>

export const INITIAL_STATE: ImmutableNotificationsState = Immutable<NotificationsState>({
  preferences: {
    loading: false,
    data: {},
  },
})

export const getNotificationPreferences = (state: ImmutableNotificationsState) =>
  state.merge(
    {
      preferences: {
        loading: true,
      },
    },
    { deep: true }
  )

export const updateNotificationPreference = (state: ImmutableNotificationsState) =>
  state.merge(
    {
      preferences: {
        loading: true,
      },
    },
    { deep: true }
  )

export const getNotificationPreferencesSuccess = (
  state: ImmutableNotificationsState,
  action: GetNotificationPreferencesSuccessPayload
) =>
  state.merge(
    {
      preferences: {
        loading: false,
        data: action.data,
      },
    },
    { deep: true }
  )

export const getNotificationPreferencesFailure = (state: ImmutableNotificationsState) =>
  state.merge(
    {
      preferences: {
        loading: false,
        data: {},
      },
    },
    { deep: true }
  )

type TState = ImmutableNotificationsState
export const reducer = createReducer<TPayloads, TActions, TState>(INITIAL_STATE, {
  [Types.GET_NOTIFICATION_PREFERENCES]: getNotificationPreferences,
  // @ts-expect-error TODO: write payload model for action & add it to TActions
  [Types.UPDATE_NOTIFICATION_PREFERENCE]: updateNotificationPreference,
  [Types.GET_NOTIFICATION_PREFERENCES_SUCCESS]: getNotificationPreferencesSuccess,
  // @ts-expect-error TODO: write payload model for action & add it to TActions
  [Types.GET_NOTIFICATION_PREFERENCES_FAILURE]: getNotificationPreferencesFailure,
  [Types.TRIGGER_NOTIFICATION_PERMISSION_MODAL]: (state) => state,
})
